// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getAccommodations as listAccommodationsAPI,
    getAccommodation as getAccommodationAPI,
    addAccommodation as addAccommodationAPI,
    updateAccommodation as updateAccommodationAPI,
    deleteAccommodation as deleteAccommodationAPI,
    getAccommodationCharts as getAccommodationChartsAPI,
    getAccommodationsForExcel as getAccommodationsForExcelAPI,
} from '../../helpers/';

import { accommodationsApiResponseError, accommodationsApiResponseSuccess } from './actions';
import { AccommodationsActionTypes } from './constants';

function* getAccommodation({ payload: { id } }) {
    try {
        const response = yield call(getAccommodationAPI, id);
        const accommodationItem = response.data.data;
        yield put(accommodationsApiResponseSuccess(AccommodationsActionTypes.GET_ACCOMMODATION, accommodationItem));
    } catch (error) {
        yield put(accommodationsApiResponseError(AccommodationsActionTypes.GET_ACCOMMODATION, error));
    }
}

function* addAccommodation({ payload: accommodation }) {
    try {
        const response = yield call(addAccommodationAPI, { ...accommodation })
        const accommodationItem = response.data
        yield put(accommodationsApiResponseSuccess(AccommodationsActionTypes.ADD_ACCOMMODATION, accommodationItem))
    } catch (error) {
        yield put(accommodationsApiResponseError(AccommodationsActionTypes.ADD_ACCOMMODATION, error))
    }
}

function* updateAccommodation({ payload: accommodation }) {
    try {
        const response = yield call(updateAccommodationAPI, { ...accommodation })
        const accommodationItem = response.data.data
        yield put(accommodationsApiResponseSuccess(AccommodationsActionTypes.UPDATE_ACCOMMODATION, accommodationItem))
    } catch (error) {
        yield put(accommodationsApiResponseError(AccommodationsActionTypes.UPDATE_ACCOMMODATION, error))
    }
}
function* deleteAccommodation({ payload: { id } }) {
    try {
        const response = yield call(deleteAccommodationAPI, id)
        const accommodationItem = response.data.id
        yield put(accommodationsApiResponseSuccess(AccommodationsActionTypes.DELETE_ACCOMMODATION, accommodationItem))
    } catch (error) {
        yield put(accommodationsApiResponseError(AccommodationsActionTypes.DELETE_ACCOMMODATION, error))
    }
}

/**
 * List contactos
 */
function* listAccommodations({ payload: params }) {
    try {
        const response = yield call(listAccommodationsAPI, { ...params });
        const listaaccommodations = response.data.data;
        yield put(accommodationsApiResponseSuccess(AccommodationsActionTypes.LIST_ACCOMMODATIONS, listaaccommodations));
    } catch (error) {
        yield put(accommodationsApiResponseError(AccommodationsActionTypes.LIST_ACCOMMODATIONS, error));
    }
}

function* getAccommodationCharts({ payload: params }) {
    try {
        const response = yield call(getAccommodationChartsAPI, { ...params });
        const dataCharts = response.data.data;
        yield put(accommodationsApiResponseSuccess(AccommodationsActionTypes.GET_ACCOMMODATION_CHARTS, dataCharts));
    } catch (error) {
        yield put(accommodationsApiResponseError(AccommodationsActionTypes.GET_ACCOMMODATION_CHARTS, error));
    }
}

function* getAccommodationsForExcel({ payload: params }) {
    try {
        const response = yield call(getAccommodationsForExcelAPI, { ...params });
        const accomodationsForExcel = response.data.data;
        yield put(accommodationsApiResponseSuccess(AccommodationsActionTypes.GET_ACCOMMODATIONS_FOR_EXCEL, accomodationsForExcel));
    } catch (error) {
        yield put(accommodationsApiResponseError(AccommodationsActionTypes.GET_ACCOMMODATIONS_FOR_EXCEL, error));
    }
}


export function* watchGetAccommodation(): any {
    yield takeEvery(AccommodationsActionTypes.GET_ACCOMMODATION, getAccommodation);
}

export function* watchListAccommodations(): any {
    yield takeEvery(AccommodationsActionTypes.LIST_ACCOMMODATIONS, listAccommodations);
}

export function* watchAddAccommodation(): any {
    yield takeEvery(AccommodationsActionTypes.ADD_ACCOMMODATION, addAccommodation)
}
export function* watchUpdateAccommodation(): any {
    yield takeEvery(AccommodationsActionTypes.UPDATE_ACCOMMODATION, updateAccommodation)
}
export function* watchDeleteAccommodation(): any {
    yield takeEvery(AccommodationsActionTypes.DELETE_ACCOMMODATION, deleteAccommodation)
}

export function* watchGetAccommodationCharts(): any {
    yield takeEvery(AccommodationsActionTypes.GET_ACCOMMODATION_CHARTS, getAccommodationCharts);
}

export function* watchGetAccommodationsForExcel(): any {
    yield takeEvery(AccommodationsActionTypes.GET_ACCOMMODATIONS_FOR_EXCEL, getAccommodationsForExcel);
}

function* accommodationsSaga(): any {
    yield all([
        fork(watchGetAccommodation),
        fork(watchListAccommodations),
        fork(watchAddAccommodation),
        fork(watchUpdateAccommodation),
        fork(watchDeleteAccommodation),
        fork(watchGetAccommodationCharts),
        fork(watchGetAccommodationsForExcel),
    ]);
}

export default accommodationsSaga;
